import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import logger from 'redux-logger'
import reducer from './rootReducer'
const middleware = [thunk]
const preloadedState = {}

if (process.env.NODE_ENV !== 'production') {
  middleware.push(logger)
}

const store = createStore(reducer, preloadedState, applyMiddleware(...middleware))

export default store
